import React from "react";

export default function ContactUs() {
  window.location.href = "https://www.webnyay.ai/contact/";
  return <div />;
}
